import { render, staticRenderFns } from "./public.vue?vue&type=template&id=9beb1454&"
import script from "./public.vue?vue&type=script&lang=js&"
export * from "./public.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports